    <div *ngIf="ehealth.connectionstatus == 'connected'" class="patientehealthicons">
        <div class="patientehealthicon">
            <fa-icon [icon]="['fas','user-check']" 
                [ngClass]="{'ehealth-noconsent':ehealth.consent.consent === false,'ehealth-consent':ehealth.consent.consent === true}"
                [matTooltip]="ehealth.consent.message" matTooltipPosition="above">
            </fa-icon>
        </div>
        <div class="patientehealthicon clickable-icon" (click)="showDMG()">
            <fa-icon [icon]="['fas','user-md']"
                [ngClass]="{'ehealth-nodmg':ehealth.dmg.dmg === false,'ehealth-dmg':ehealth.dmg.dmg === true && ehealth.dmg.error == 'none','ehealth-wrongpatientdmg':ehealth.dmg.dmg === true && ehealth.dmg.error == 'patient'}"
                [matTooltip]="ehealth.dmg.message" matTooltipPosition="above">
            </fa-icon>
            <fa-icon class="ehealth-notauth-icon" *ngIf="ehealth.dmg.error == 'notauthorized'"
                [icon]="['fas','ban']"
                [matTooltip]="ehealth.dmg.message" matTooltipPosition="above">
            </fa-icon>
            <fa-icon class="ehealth-warning-icon" *ngIf="ehealth.dmg.error == 'failed'"
                [icon]="['fas','exclamation-triangle']"
                [matTooltip]="ehealth.dmg.message" matTooltipPosition="above">
            </fa-icon>
            <fa-icon class="ehealth-alert-icon" *ngIf="ehealth.dmg.warning"
                [icon]="['fas','lightbulb']"
                [matTooltip]="ehealth.dmg.message" matTooltipPosition="above">
            </fa-icon>
        </div>
        <div class="patientehealthicon clickable-icon" (click)="showInsurability()">
            <fa-icon [icon]="['fas','user-shield']"
                [ngClass]="{'ehealth-noinsurability':ehealth.insurability.active === false,'ehealth-insurability':ehealth.insurability.active === true}"
                [matTooltip]="ehealth.insurability.message"
                matTooltipClass="insurability-tooltip"
                matTooltipPosition="above">
            </fa-icon>
            <fa-icon class="ehealth-warning-icon" *ngIf="ehealth.insurability.error"
                [icon]="['fas','exclamation-triangle']"
                [matTooltip]="ehealth.insurability.message" matTooltipPosition="above">
            </fa-icon>
            <fa-icon class="ehealth-error-icon" *ngIf="insurabilityDiffers"
                [icon]="['fas','exclamation-triangle']"
                matTooltip="Assurabilité pas conforme aux données présentes dans le signalétique patient" matTooltipPosition="above">
            </fa-icon>
        </div>
    </div>
    <div *ngIf="ehealth.connectionstatus == 'connected'" class="patientehealthicons">
        <div class="patientehealthicon">
            <fa-icon [icon]="['fas','user-friends']"
                [ngClass]="{'ehealth-therlinks':ehealth.therlinks.status == 'none','ehealth-notherlinks':ehealth.therlinks.error === true,'ehealth-oktherlinks':ehealth.therlinks.error === false}"
                [matTooltip]="ehealth.therlinks.message"
                matTooltipPosition="above">
            </fa-icon>
        </div>
        <div class="patientehealthicon clickable-icon" (click)="showHubTransactionsClick()">
            <fa-icon [icon]="['fas','folder']"
                [ngClass]="{'ehealth-notransactions':ehealth.transactions.status === 'none','ehealth-errortransactions':ehealth.transactions.status === 'error','ehealth-oktransactions':ehealth.transactions.status === 'some'}"
                [matTooltip]="ehealth.transactions.message"
                matTooltipPosition="above">
            </fa-icon>{{ ehealth.transactions.list.length }}
        </div>
    </div>
